'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthGrid = require('@narvar/nth-grid');
var TextLink = require('@narvar/nth-bit-text-link');
var nthHookTheme = require('@narvar/nth-hook-theme');
var nthHookSettings = require('@narvar/nth-hook-settings');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var nthHookContextAnalytics = require('@narvar/nth-hook-context-analytics');
var index$1 = require('./components/NarvarLogo/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var TextLink__default = /*#__PURE__*/_interopDefaultLegacy(TextLink);

const DEFAULT_LOGO_HREF = 'https://corp.narvar.com/survey';
const NarvarFooter = _ref => {
  let {
    featureName,
    experienceHost,
    hack_paddingOverride
  } = _ref;
  const {
    settings,
    loading
  } = nthHookSettings.useSettingsX();
  const {
    logoHref,
    hideLogo,
    hideInEmbed,
    hidePrivacyLink
  } = settings.narvarFooter ?? {};
  const {
    narvarfooterNoneNone,
    linksLegalDefault,
    linksLegalHover,
    iconsFooterNone
  } = nthHookTheme.useTheme();
  const {
    footerPrivacyLinkText,
    footerPrivacyLink
  } = nthHookTranslations.useTranslations();
  const logEvent = nthHookContextAnalytics.useAnalyticsPost();
  React.useEffect(() => {
    logEvent({
      feature: featureName,
      eventComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_BUNDLE_NARVAR_FOOTER,
      eventFeature: nthHookContextAnalytics.NarvarEventComponents.NTH_BUNDLE_NARVAR_FOOTER,
      pageComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_BUNDLE_NARVAR_FOOTER,
      eventType: nthHookContextAnalytics.NarvarEventTypes.COMPONENT_RENDER
    });
  },
  // TODO: Make this dependency array exhaustive
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  const LogoBlock = /*#__PURE__*/React__default["default"].createElement(nthGrid.Column, {
    "xs-columns": 6,
    style: {
      padding: 0,
      textAlign: 'left'
    }
  }, /*#__PURE__*/React__default["default"].createElement("a", {
    href: logoHref || DEFAULT_LOGO_HREF,
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React__default["default"].createElement(index$1["default"], {
    style: iconsFooterNone
  })));
  const LinksBlock = /*#__PURE__*/React__default["default"].createElement(nthGrid.Column, {
    "xs-columns": 6,
    style: {
      marginTop: '0.8rem',
      fontFamily: 'Helvetica',
      fontSize: '0.65rem',
      fontWeight: 300,
      height: '0.75rem',
      textAlign: 'right'
    }
  }, /*#__PURE__*/React__default["default"].createElement(TextLink__default["default"], {
    linkStyle: {
      sDefault: {
        fontFamily: 'Helvetica Neue, Helvetica, Arial, sans-serif',
        margin: '0 0.125rem',
        fontSize: '0.625rem',
        fontWeight: 300,
        lineHeight: '0.75rem',
        letterSpacing: '0.3px',
        color: '#999',
        textDecoration: 'none',
        ...linksLegalDefault
      },
      sHover: {
        margin: '0 0.125rem',
        fontSize: '0.625rem',
        color: linksLegalHover && linksLegalHover.color || '#999',
        ...linksLegalHover
      }
    },
    href: footerPrivacyLink || 'https://corp.narvar.com/terms/',
    target: TextLink.TextLinkTargetType.BLANK,
    rel: "noopener noreferrer"
  }, footerPrivacyLinkText));
  const isEmbed = experienceHost === 'EMBED';
  if (loading || isEmbed && hideInEmbed) return null;
  return /*#__PURE__*/React__default["default"].createElement("footer", null, /*#__PURE__*/React__default["default"].createElement(nthGrid.Row, {
    "lg-style": hack_paddingOverride ?? (isEmbed ? 'padding: 0.625rem 0 0.5rem;' : 'padding: 0.625rem 0 6.25rem;'),
    "md-style": hack_paddingOverride ?? (isEmbed ? 'padding: 1.25rem 1.25rem 0.5rem;' : 'padding: 1.25rem 1.25rem 5rem;'),
    "xs-style": hack_paddingOverride ?? (isEmbed ? 'padding: 0.625rem 1.25rem 0.5rem;' : 'padding: 0.625rem 1.25rem 5rem;'),
    style: {
      margin: 0,
      borderTop: '0.0625rem solid #ccc',
      // TODO: remove #FFF background color from
      // default narvarfooterNoneNone styling
      ...narvarfooterNoneNone,
      backgroundColor: isEmbed ? undefined : narvarfooterNoneNone && narvarfooterNoneNone.backgroundColor
    }
  }, !hideLogo && LogoBlock, !isEmbed && !hidePrivacyLink && LinksBlock));
};
var index = nthHookSettings.withSettingsProvider(nthHookTranslations.withTranslationsProvider(nthHookTheme.withThemeProvider(NarvarFooter, {
  themeTokens: ['narvarfooterNoneNone', 'linksLegalDefault', 'linksLegalHover', 'iconsFooterNone']
}), {
  translationKeys: ['footerPrivacyLinkText', 'footerPrivacyLink']
}), {
  settingsRequested: `
      narvarFooter {
        logoHref
        hideLogo
        hideInEmbed
        hidePrivacyLink
      }
    `
});

exports.NarvarLogo = index$1["default"];
exports["default"] = index;
